import React, { useEffect, useState } from "react";
import { ORIENTATION, s3Link } from "../../utils/constants";
import LockIcon from "../../images/silver-app.png";
import UnlockPurchaseButton from "./unlocked-purchase-button";
import PVideo from "../PVideo";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Duration from "../Duration";
import { LazyLoadImage } from "react-lazy-load-image-component";
import './style.scss';
import Thumbprint from "../Thumbprint";

const Media = ({ media, hasPortrait, hasEqual, message, autoplay = true, showBlurred = false, showMultiple = false, containerClass = '' }) => {
    const [isVideo, setIsVideo] = useState(false);
    const [width, setWidth] = useState(1080);
    const [height, setHeight] = useState(2640);
    const [aspectRatioClass, setAspectRationClass] = useState('');

    const checkAspectRatio = (ratio) => {
        if (parseFloat(ratio) >= .58 && parseFloat(ratio) < .90) {
            return (' p_3_4');
        } else if (parseFloat(ratio) >= .42 && parseFloat(ratio) <= .57) {
            return (' p_9_16');
        } else if (parseFloat(ratio) <= .41) {
            return (' p_9_22');
        } else if (parseFloat(ratio) == 1) {
            return (' p_1_1');
        } else if (parseFloat(ratio) == 1.33) {
            return (' l_3_4');
        } else if (parseFloat(ratio) >= 1.34 && parseFloat(ratio) <= 2.43) {
            return (' l_9_16');
        } else if (parseFloat(ratio) >= 2.44) {
            return (' l_9_22');
        } else {
            return (' p_1_1');
        }
    };

    useEffect(() => {
        $.fancybox.defaults.hash = false;
        $.fancybox.defaults.protected = true;
        $.fancybox.defaults.loop = true;
        $.fancybox.defaults.slideShow = false;
        $.fancybox.defaults.smallBtn = false;
        $.fancybox.defaults.idleTime = false;
        $.fancybox.defaults.hideScrollbar = true;
        $.fancybox.defaults.closeExisting = false;
        $.fancybox.defaults.mobile = {
            clickSlide: 'close'
        };
        $.fancybox.defaults.touch = {
            vertical: false
        };

        setHeight(window.screen.height);
        setWidth(window.screen.width);
    }, []);

    useEffect(() => {
        setAspectRationClass(checkAspectRatio(media.aspect_ratio));
    }, [media]);

    let orientationClass = 'media__auto';
    if (media.orientation == ORIENTATION.LANDSCAPE) {
        orientationClass = 'media__landscape';
    }

    if (media.orientation == ORIENTATION.PORTRAIT) {
        orientationClass = 'media__portrait';
    }

    if (media.orientation == ORIENTATION.EQUAL) {
        orientationClass = 'media__equal';
    }

    if (showBlurred) {
        return <div
            className={`message__image ${hasPortrait ? 'media__portrait' : (hasEqual ? 'media__equal' : 'media__landscape')}`}
        >
            <div className={`${aspectRatioClass ? aspectRatioClass : ''}`}>
                {
                    parseFloat(message.price) > 0 && !message.has_free_preview && message.is_lock !== 1 && <img src={LockIcon} className="message-ppv__lock-icon" />
                }

                <img onContextMenu={e => e.preventDefault()} src={`${s3Link}/${media.blurred_path}`} />
            </div>
        </div>;
    }

    if (showMultiple) {
        return <div
            className={`message__image ${containerClass} message-ppv__multiple`}
        >
            <div className='message-ppv__multiple-lock'>
                <img src={LockIcon} />
            </div>
            <div className='message-ppv__multiple-unlock'>
                <UnlockPurchaseButton message={message} setShowCcForm={setShowCcForm} />
            </div>
        </div>;
    }

    const handlePlayVideo = (e) => {
        setIsVideo(true);
    };

    // add checking of ratio and add class
    if (media.type.toUpperCase() === 'VIDEO') {
        let imgSrc = media.thumb_path;

        if (media.large_path) {
            imgSrc = media.large_path;
        }

        if (!imgSrc) {
            imgSrc = media.file_path;
        }

        const HiddenVideo = () => {
            return <div
                onContextMenu={e => e.preventDefault()}
                id={`media-${message.id}-${media.media_id}`}
                style={{
                    display: 'none',
                    padding: 0
                }}
                className={`${media.orientation == ORIENTATION.PORTRAIT ? 'hidden-media__portrait' : (media.orientation == ORIENTATION.EQUAL ? 'hidden-media__equal' : 'hidden-media__landscape')}`}>
                <PVideo
                    thumb={media.thumb_path ? `${s3Link}/${media.thumb_path}` : ''}
                    video={`${s3Link}/${media.file_path}`}
                    preload="meta"
                    className="embed-responsive-item"
                    autoplay={autoplay}
                    muted={true}
                    style={{ width: '100%' }}
                    onContextMenu={e => e.preventDefault()}
                />
            </div>;
        };

        return !isVideo ? <div
            className={`video-thumb ${hasPortrait ? 'media__portrait' : (hasEqual ? 'media__equal' : 'media__landscape')}`}
            style={{ messageition: 'relative' }}
        >
            <a
                className="cust-fancybox"
                data-fancybox={'media-slider-' + `${message.id}`}
                data-protect="true"
                data-src={`#media-${message.id}-${media.media_id}`}
                onClick={(e) => e.preventDefault()}
            >
                <div
                    className={`message__image`}
                >
                    <div className={`${aspectRatioClass ? aspectRatioClass : ''}`}>
                        <img onContextMenu={e => e.preventDefault()} src={`${s3Link}/${imgSrc}`} />
                    </div>
                </div>

                <HiddenVideo />
            </a>

            <span className="play-icon" style={{ zIndex: '99', padding: '12px 16px 12px 20px', width: '56px', height: '56px', borderRadius: '28px', cursor: 'pointer' }} onClick={handlePlayVideo}>
                <FontAwesomeIcon icon={['fas', 'play']} />
            </span>
            {
                media.free_preview && <div className="su-free-preview__label" style={{ position: 'absolute', fontWeight: 'normal' }}>Free Preview</div>
            }
            <Duration duration={media.vid_duration} />
        </div>
            : <div
                className={`is-video`}
                onContextMenu={e => e.preventDefault()}
            >
                <div
                    className={`${aspectRatioClass ? aspectRatioClass : ''}`}
                    onContextMenu={e => e.preventDefault()}
                >
                    <a
                        className="cust-fancybox"
                        data-fancybox={'media-slider-' + `${message.id}`}
                        data-protect="true"
                        style={{ width: '100%' }}
                        href="#"
                        onContextMenu={e => e.preventDefault()}
                        data-src={`#media-${message.id}-${media.media_id}`}
                    >
                        <PVideo
                            thumb={imgSrc ? `${s3Link}/${imgSrc}` : ''}
                            video={`${s3Link}/${media.file_path}`}
                            preload="meta"
                            className="embed-responsive-item"
                            autoplay={autoplay}
                            muted={true}
                            style={{ width: '100%', zIndex: 99 }}
                            onContextMenu={e => e.preventDefault()}
                        />
                        <HiddenVideo />
                    </a>
                </div>
            </div>;
    } else if (media.type.toUpperCase() === 'IMAGE') {
        let imgSrc;

        if (media.large_path) {
            imgSrc = media.large_path;
        } else {
            imgSrc = media.thumb_path;
        }
        return <div
            className={`message__image ${hasPortrait ? 'media__portrait' : (hasEqual ? 'media__equal' : 'media__landscape')}`}
            onContextMenu={e => e.preventDefault()}
        >
            <div className={`${aspectRatioClass ? aspectRatioClass : ''}`} onContextMenu={e => e.preventDefault()}>
                <>
                    <div className={'chat-gallery-thumbprint'}><Thumbprint /></div>
                    <LazyLoadImage onContextMenu={e => e.preventDefault()} src={`${s3Link}/${imgSrc}`} />
                </>
                {
                    media.free_preview && <div className="su-free-preview__label" style={{ position: 'absolute', fontWeight: 'normal' }}>Free Preview</div>
                }
            </div>
        </div>;
    } else {
        return <div>Unknown media.</div>;
    }
};


export default React.memo(Media);
